import React, { useState } from 'react';
import { useTranslations } from 'use-intl';
import ConfirmModal from '@/stories/Components/ConfirmModal/ConfirmModal';
import { useSupabaseStore } from '../supabaseStore';
import { useChatStore } from '../useChat';

interface ArchiveModalProps {
	isOpen: boolean;
	onClose: () => void;
}

const ArchiveModal: React.FC<ArchiveModalProps> = ({ isOpen, onClose }) => {
	const t = useTranslations('Support');
	const supabase = useSupabaseStore((state) => state.supabase);
	const { selectedChat } = useChatStore();
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState('');

	const handleArchive = async () => {
		if (!supabase || !selectedChat?.id) return;
		setIsLoading(true);
		setError('');
		try {
			const { data, error: archiveError } = await supabase.functions.invoke(
				'chat-customer-support-status-transition',
				{
					body: {
						chatId: selectedChat.id,
						event: 'CUSTOMER_SUPPORT_REPRESENTATIVE_ARCHIVES',
						metadata: {
							archivedAt: new Date().toISOString()
						}
					}
				}
			);
			if (archiveError) throw archiveError;
			if (data && !data.success) {
				throw new Error(data.error || 'Unknown error occurred');
			}
			handleClose();
		} catch (err) {
			console.error('Error archiving chat:', err);
			setError(t('ErrorArchivingChat') || 'Error archiving chat');
		} finally {
			setIsLoading(false);
		}
	};

	const handleClose = () => {
		onClose();
		setError('');
	};

	return (
		<ConfirmModal
			isOpen={isOpen}
			onClose={handleClose}
			title={t('ArchiveTitle')}
			subtitle={t('ArchiveDescription')}
			confirmActionText={t('ArchiveTitle')}
			onConfirm={handleArchive}
			onCancel={handleClose}
			confirmBtnLoading={isLoading}
			confirmBtnTestId="archiveConfirmBtn"
			cancelBtnTestId="archiveCancelBtn"
			type="confirm"
		>
			{error && <div className="mt-4 text-red-500 text-sm">{error}</div>}
		</ConfirmModal>
	);
};

export default ArchiveModal;
